import {schemaMethods} from '@witkac/jschema';

export const filters = {
  toWords: schemaMethods.toWords,
  toWordsMoney: schemaMethods.toWordsMoney,
  fmoney: schemaMethods.fmoney,
  fmoneySpace: schemaMethods.fmoneySpace,
  padNumber: schemaMethods.padNumber,
  datePart: schemaMethods.datePart,
  dateFromPesel: schemaMethods.dateFromPesel,
  moment: schemaMethods.moment,
  fdatetime: schemaMethods.fdatetime,
  fdate: schemaMethods.fdate,
  ftime: schemaMethods.ftime,
  dateFromPesel: schemaMethods.dateFromPesel,
  datePart: schemaMethods.datePart
};

export function registerFilters(Vue, registerLog) {
  for (var name in filters) {
    if (registerLog) {
      console.time('register filter ' + name);
      Vue.filter(name, filters[name]);
      console.timeEnd('register filter ' + name);
    } else {
      Vue.filter(name, filters[name]);
    }
  }
}

export default filters;
